import React, { useState, useEffect } from "react";
import { Divider } from "primereact/divider";                   
import { Dropdown as Primedropdown } from "primereact/dropdown";
import GlobalVariable from "../../../services/globalVar.js";
import LedgerService from "../../../services/ledger.js";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import ReportsService from "../../../services/reports.js";
import { Calendar } from "primereact/calendar";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { DatePicker, Space } from "antd";
import {
  InsertRowBelowOutlined,
  InsertRowRightOutlined,
} from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
import moment from "moment";
import BalanceSheet from "./BalanceSheet.js";
import SalesByCust from "./SalesByCust.js";
import SalesByItems from "./SalesByItems.js";
import ProfitandLoss from "./ProfitandLoss.js";
import PurchasebyVendor from "./PurchasebyVendor.js";
import PurchasebyItem from "./PurchasebyItem.js";
import CustomerBalance from "./Receivables/CustomerBalance.js";
import VendorBalance from "./Payables/VendorBalance.js";
import InvoiceDetails from "./Receivables/InvoiceDetails.js";
import EstimateDetails from "./Receivables/EstimateDetails.js";
import { Button } from "primereact/button";
import * as XLSX from "xlsx";
import PaymentsReceived from "./Payments Received/PaymentsReceived.js";
import ExpenseSummarybyCategory from "./Purchase and Expenses/ExpenseSummarybyCategory.js";
import TimetoGetPaid from "./Payments Received/TimetoGetPaid.js";
import TaxSummary from "./Taxes/TaxSummary.js";
import CashFlow from "./CashFlow.js";
import BankTransaction from "../../Banking/BankTransaction.js";
import SalesReturn from "./SalesReturn.js";
import PurchaseReturn from "./Purchase and Expenses/PurchaseReturn.js";
import SalesTaxSummary from "./Taxes/SalesTaxSummary.js";
import { saveAs } from "file-saver";

const ReportsCenter = () => {
  const rs = new ReportsService();
  //     useEffect(() => {
  //   return () => {
  //     Object.values(rs.controllers).forEach((c) => c.abort());
  //     rs.controllers = {}; 
  //   };
  // }, []);
  const currency = GlobalVariable.userDet.tenantConfig.currency;
  const [totalRecordsIn, setTotalRecordsIn] = useState(0);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [showAll, setShowAll] = useState(true);
  const [isAccDetails, setIsAccDetails] = useState(false);
  const [selectedItemDetails, setSelectedItemDetails] =
    useState("Reports Center");
  const [isProcess, setIsProcess] = useState(false);
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [ledgerList, setLedgerList] = useState([]);
  const [passDteRange, setPassDteRange] = useState([]);
  const [profitAndLossDatas, setProfitAndLossDatas] = useState([]);
  const [profitAndLossDatas1, setProfitAndLossDatas1] = useState([]);
  const [profitAndLossDatas2, setProfitAndLossDatas2] = useState([]);
  const [saleByCust, setSaleByCust] = useState([]);
  const [saleByItem, setSaleByItem] = useState([]);
  const [showBasedOnChild, setShowBasedOnChild] = useState("");
  const [summary, setSummary] = useState([]);
  const [salesSummary, setSalesSummary] = useState([]);
  const [itemsTaxSummary, setItemsTaxSummary] = useState([]);
  const [selectPeriod, setSelectPeriod] = useState("Last 3 Months");
  const [isRowView, setIsRowView] = useState(true);
  const [expandedRows, setExpandedRows] = useState(null);
  const [fromDates, setfromDates] = useState();
  const [toDates, setToDates] = useState();
  const [balanceSheetAssets, setBalanceSheetAssets] = useState([]);
  const [balanceSheetLiability, setBalanceSheetLiability] = useState([]);
  const [purchasebyVendor, setPurchasebyVendor] = useState([]);
  const [purchasebyItem, setPurchasebyItem] = useState([]);
  const [purchaseReportSummary, setPurchaseReportSummary] = useState([]);
  const [custBalance, setCustBalance] = useState([]);
  const [vendorBalance, setVendorBalance] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [estimateDetails, setEstimateDetails] = useState([]);
  const [exportDatas, setExportDatas] = useState([]);
  const [paymentReceved, setPaymentReceved] = useState([]);
  const [expenseSummaryByCat, setExpenseSummaryByCat] = useState([]);
  const [taxSummary, setTaxSummary] = useState([]);
  const [toGetPaid, setToGetPaid] = useState([]);
  const [cashFlow, setCashFlow] = useState([]);
  const [salesReturn, setSalesReturn] = useState([]);
  const [purchaseReturn, setPurchaseReturn] = useState([]);
  const [spTaxSummary, setSpTaxSummary] = useState([]);
  const [total, setTotal] = useState();
  const { RangePicker } = DatePicker;

  const headers = [
    "Vendor Name",
    "Expense Count",
    "Amount",
    "Amount (With Tax)",
  ];
  const headers1 = [
    "Item Name",
    "Quantity",
    "Unit Price",
    "Amount",
  ];

  const menuList = [
    {
      id: 0,
      name: "all",
      label: "All",
      value: "All",
      children: [
        { id: 1.1, name: "summary", label: "Summary", value: "Summary" },
        // { id: 1.2, name: "dashboard", label: "Dashboard", value: "Dashboard" },
      ],
    },
    {
      id: 1,
      name: "businessOverview",
      label: "Business Overview",
      value: "Business Overview",
      children: [
        {
          id: 1.1,
          name: "profitandloss",
          label: "Profit and Loss",
          value: "profitandloss",
          parent: "Business Overview"
        },
        {
          id: 1.2,
          name: "cashflowstatement",
          label: "Cash Flow Statement",
          value: "cashflowstatement",
          parent: "Business Overview"

        },
        {
          id: 1.3,
          name: "balancesheet",
          label: "Balance Sheet",
          value: "balancesheet",
          parent: "Business Overview"

        },
      ],
    },
    {
      id: 18,
      name: "banking",
      label: "Banking ",
      value: "Banking ",
      children: [
        {
          id: 18.1,
          name: "BankingSummary",
          label: "Banking Summary",
          value: "Banking Summary",
          parent: "Banking"

        },
        
      ],
    },
    {
      id: 2, 
      name: "sales",
      label: "Sales",
      value: "Sales",
      children: [
        {
          id: 2.1,
          name: "salesByCustomer",
          label: "Sales by Customer",
          value: "Sales by Customer",
          parent: "Sales"

        },
        {
          id: 2.2,
          name: "salesByItem",
          label: "Sales by Item",
          value: "Sales by Item",
          parent: "Sales"

        },
        // {
        //   id: 2.3,
        //   name: "salesReport",
        //   label: "Sales Return",
        //   value: "Sales Return",
        //   parent: "Sales"

        // },
      ],
    },
    // {
    //   id: 3,
    //   name: "inventory",
    //   label: "Inventory",
    //   value: "Inventory",
    //   children: [
    //     {
    //       id: 3.1,
    //       name: "inventorysummary",
    //       label: "Inventory Summary",
    //       value: "inventorysummary",
    //     },
    //     {
    //       id: 3.2,
    //       name: "inventoryvaluationsummary",
    //       label: "Inventory Valuation Summary",
    //       value: "inventoryvaluationsummary",
    //     },
    //     {
    //       id: 3.3,
    //       name: "FIFOcostlottracking",
    //       label: "FIFO Cost Lot Tracking",
    //       value: "FIFOcostlottracking",
    //     },
    //     {
    //       id: 3.4,
    //       name: "productsalesreport",
    //       label: "Product Sales Report",
    //       value: "productsalesreport",
    //     },
    //   ],
    // },

    {
      id: 7,
      name: "receivables",
      label: "Receivables",
      value: "Receivables",
      children: [
        {
          id: 7.1,
          name: "customerBalances",
          label: "Customer Balances",
          value: "Customer Balances",
          parent: "Receivables"

        },
        // {
        //   id: 7.2,
        //   name: "ARAgingSummaryByInvoiceDueDate",
        //   label: "AR Aging Summary By Invoice Due Date",
        //   value: "AR Aging Summary By Invoice Due Date",
        // },
        // {
        //   id: 7.3,
        //   name: "ARAgingDetailsByInvoiceDueDate",
        //   label: "AR Aging Details By Invoice Due Date",
        //   value: "AR Aging Details By Invoice Due Date",
        // },
        {
          id: 7.4,
          name: "invoiceDetails",
          label: "Invoice Details",
          value: "Invoice Details",
          parent: "Receivables"

        },
        // {
        //   id: 7.5,
        //   name: "retainerInvoiceDetails",
        //   label: "Retainer Invoice Details",
        //   value: "Retainer Invoice Details",
        // },
        // {
        //   id: 7.6,
        //   name: "salesOrderDetails",
        //   label: "Sales Order Details",
        //   value: "Sales Order Details",
        // },
        // {
        //   id: 7.7,
        //   name: "deliveryChallanDetails",
        //   label: "Delivery Challan Details",
        //   value: "Delivery Challan Details",
        // },
        {
          id: 7.8,
          name: "estimateDetails",
          label: "Estimate Details",
          value: "Estimate Details",
          parent: "Receivables"

        },
      ],
    },
    {
      id: 8,
      name: "paymentsReceived",
      label: "Payments Received",
      value: "Payments Received",
      children: [
        {
          id: 8.1,
          name: "paymentsReceived",
          label: "Payments Received",
          value: "Payments Received",
          parent: "Payments Received"

        },
        {
          id: 8.2,
          name: "timetoGetPaid",
          label: "Time to Get Paid",
          value: "Time to Get Paid",
          parent: "Payments Received"

        },
        // {
        //   id: 8.3,
        //   name: "creditNoteDetails",
        //   label: "Credit Note Details",
        //   value: "Credit Note Details",
        // },
        // {
        //   id: 8.4,
        //   name: "refundHistory",
        //   label: "Refund History",
        //   value: "Refund History",
        // },
      ],
    },
    // {
    //   id: 9,
    //   name: "recurringInvoices",
    //   label: "Recurring invoices",
    //   value: "Recurring invoices",
    //   children: [
    //     {
    //       id: 9.1,
    //       name: "recurringInvoiceDetails",
    //       label: "Recurring Invoice Details",
    //       value: "Recurring Invoice Details",
    //     },
    //   ],
    // },
    {
      id: 10,
      name: "payables",
      label: "Payables",
      value: "Payables",
      children: [
        {
          id: 10.1,
          name: "vendorBalances",
          label: "Vendor Balances",
          value: "Vendor Balances",
          parent: "Payables"

        },
        // {
        //   id: 10.2,
        //   name: "APAgingSummaryByBillDueDate",
        //   label: "AP Aging Summary By Bill Due Date",
        //   value: "AP Aging Summary By Bill Due Date",
        // },
        // {
        //   id: 10.3,
        //   name: "APAgingDetailsByBillDueDate",
        //   label: "AP Aging Details By Bill Due Date",
        //   value: "AP Aging Details By Bill Due Date",
        // },
        // {
        //   id: 10.4,
        //   name: "billsDetails",
        //   label: "Bills Details",
        //   value: "Bills Details",
        // },
        // {
        //   id: 10.5,
        //   name: "vendorCreditsDetails",
        //   label: "Vendor Credits Details",
        //   value: "Vendor Credits Details",
        // },
        // {
        //   id: 10.6,
        //   name: "paymentsMade",
        //   label: "Payments Made",
        //   value: "Payments Made",
        // },
        // {
        //   id: 10.7,
        //   name: "refundHistory",
        //   label: "Refund History",
        //   value: "Refund History",
        // },
        // {
        //   id: 10.8,
        //   name: "purchaseOrderDetails",
        //   label: "Purchase Order Details",
        //   value: "Purchase Order Details",
        // },
        // {
        //   id: 10.9,
        //   name: "purchaseOrdersbyVendor",
        //   label: "Purchase Orders by Vendor",
        //   value: "Purchase Orders by Vendor",
        // },
      ],
    },
    {
      id: 11,
      name: "purchaseAndExpenses",
      label: "Purchase and Expenses",
      value: "Purchase and Expenses",
      children: [
        {
          id: 11.1,
          name: "purchasesbyVendor",
          label: "Purchases by Vendor",
          value: "Purchases by Vendor",
          parent: "Purchase and Expenses"

        },
        {
          id: 11.2,
          name: "purchasesbyItem",
          label: "Purchases by Item",
          value: "Purchases by Item",
          parent: "Purchase and Expenses"

        },
        // {
        //   id: 11.3,
        //   name: "expenseDetails",
        //   label: "Expense Details",
        //   value: "Expense Details",
        // },
        {
          id: 11.4,
          name: "expenseSummarybyCategory",
          label: "Expense Summary by Category",
          value: "Expense Summary by Category",
          parent: "Purchase and Expenses"

        },
        {
          id: 11.5,
          name: "purchaseReturn",
          label: "Purchase Return",
          value: "Purchase Return",
          parent: "Purchase and Expenses"

        },
        // {
        //   id: 11.5,
        //   name: "expensesbyCustomer",
        //   label: "Expenses by Customer",
        //   value: "Expenses by Customer",
        // },
        // {
        //   id: 11.6,
        //   name: "expensesbyProject",
        //   label: "Expenses by Project",
        //   value: "Expenses by Project",
        // },
        // {
        //   id: 11.7,
        //   name: "expensesbyEmployee",
        //   label: "Expenses by Employee",
        //   value: "Expenses by Employee",
        // },
      ],
    },
    {
      id: 12,
      name: "taxes",
      label: "Taxes",
      value: "Taxes",
      children: [
        {
          id: 12.1,
          name: "taxSummary",
          label: "Tax Summary",
          value: "Tax Summary",
          parent: "Taxes"

        },
        {
          id: 12.2,
          name: "salesTaxSummary",
          label: "Sales Tax Summary",
          value: "Sales Tax Summary",
          parent: "Taxes"

        },
        {
          id: 12.3,
          name: "purchaseTaxSummary",
          label: "Purchase Tax Summary",
          value: "Purchase Tax Summary",
          parent: "Taxes"

        },
      ],
    },
    // {
    //   id: 13,
    //   name: "projectsAndTimesheets",
    //   label: "Projects and Timesheets",
    //   value: "Projects and Timesheets",
    //   children: [
    //     {
    //       id: 12.1,
    //       name: "timesheetDetails",
    //       label: "Timesheet Details",
    //       value: "Timesheet Details",
    //     },
    //     {
    //       id: 12.2,
    //       name: "projectSummary",
    //       label: "Project Summary",
    //       value: "Project Summary",
    //     },
    //     {
    //       id: 12.3,
    //       name: "projectDetails",
    //       label: "Project Details",
    //       value: "Project Details",
    //     },
    //   ],
    // },
    // {
    //   id: 14,
    //   name: "accountant",
    //   label: "Accountant",
    //   value: "Accountant",
    //   children: [
    //     {
    //       id: 13.1,
    //       name: "accountTransactions",
    //       label: "Account Transactions",
    //       value: "Account Transactions",
    //     },
    //     {
    //       id: 13.2,
    //       name: "accountTypeSummary",
    //       label: "Account Type Summary",
    //       value: "Account Type Summary",
    //     },
    //     {
    //       id: 13.3,
    //       name: "generalLedger",
    //       label: "General Ledger",
    //       value: "General Ledger",
    //     },
    //     {
    //       id: 13.4,
    //       name: "detailedGeneralLedger",
    //       label: "Detailed General Ledger",
    //       value: "Detailed General Ledger",
    //     },
    //     {
    //       id: 13.5,
    //       name: "journalReport",
    //       label: "Journal Report",
    //       value: "Journal Report",
    //     },
    //     {
    //       id: 13.6,
    //       name: "trialBalance",
    //       label: "Trial Balance",
    //       value: "Trial Balance",
    //     },
    //   ],
    // },
    // {
    //   id: 15,
    //   name: "currency",
    //   label: "Currency",
    //   value: "Currency",
    //   children: [
    //     {
    //       id: 14.1,
    //       name: "realizedGainorLoss",
    //       label: "Realized Gain or Loss",
    //       value: "Realized Gain or Loss",
    //     },
    //   ],
    // },
    // {
    //   id: 16,
    //   name: "activity",
    //   label: "Activity",
    //   value: "Activity",
    //   children: [
    //     {
    //       id: 15.1,
    //       name: "userActivity",
    //       label: "User Activity",
    //       value: "User Activity",
    //     },
    //     {
    //       id: 15.2,
    //       name: "systemLogs",
    //       label: "System Logs",
    //       value: "System Logs",
    //     },
    //   ],
    // },
  ];

  // const handleToggle = () => {
  //   setIsRowView(!isRowView);
  //   if(!isRowView) {
  //     setIsAccDetails(true);
  //     setShowBasedOnChild("profitandloss");
  //     setIsRowView(false);
  //   }

  // };

  const handleToggle = () => {
    setIsRowView((prevView) => {
      const newView = !prevView;
      // if (prevView) {
      //   runReport();
      // }
      return newView;
    });
  };

  const expenseDetails = [
    {
      status: "Completed",
      date: "2024-09-01",
      vendorName: "Tech Solutions Inc.",
      customerName: "John Smith",
      amount: 150.0,
      amountWithTax: 165.0,
    },
    {
      status: "Pending",
      date: "2024-09-02",
      vendorName: "Office Supplies Co.",
      customerName: "Jane Doe",
      amount: 200.0,
      amountWithTax: 220.0,
    },
    {
      status: "Cancelled",
      date: "2024-09-03",
      vendorName: "Gadget World",
      customerName: "Michael Johnson",
      amount: 120.0,
      amountWithTax: 132.0,
    },
    {
      status: "Completed",
      date: "2024-09-04",
      vendorName: "Furniture Depot",
      customerName: "Emily Davis",
      amount: 180.0,
      amountWithTax: 198.0,
    },
    {
      status: "Pending",
      date: "2024-09-05",
      vendorName: "ElectroMart",
      customerName: "Chris Brown",
      amount: 250.0,
      amountWithTax: 275.0,
    },
  ];


  const expenseByCust = [
    {
      customerName: "John Smith",
      expenseCount: 5,
      expenseAmount: 100.0,
      expenseAmountWithTax: 110.0,
    },
    {
      customerName: "Jane Doe",
      expenseCount: 3,
      expenseAmount: 250.0,
      expenseAmountWithTax: 275.0,
    },
    {
      customerName: "Michael Johnson",
      expenseCount: 8,
      expenseAmount: 400.0,
      expenseAmountWithTax: 440.0,
    },
    {
      customerName: "Emily Davis",
      expenseCount: 2,
      expenseAmount: 60.0,
      expenseAmountWithTax: 66.0,
    },
    {
      customerName: "Chris Brown",
      expenseCount: 7,
      expenseAmount: 150.0,
      expenseAmountWithTax: 165.0,
    },
  ];

  const expenseByEmployee = [
    {
      status: "Completed",
      date: "2024-09-01",
      vendorName: "Tech Solutions Inc.",
      category: "Electronics",
      customerName: "John Smith",
      transactionType: "Purchase",
      amount: 150.0,
      amountWithTax: 165.0,
    },
    {
      status: "Pending",
      date: "2024-09-02",
      vendorName: "Office Supplies Co.",
      category: "Office Supplies",
      customerName: "Jane Doe",
      transactionType: "Purchase",
      amount: 200.0,
      amountWithTax: 220.0,
    },
    {
      status: "Cancelled",
      date: "2024-09-03",
      vendorName: "Gadget World",
      category: "Electronics",
      customerName: "Michael Johnson",
      transactionType: "Refund",
      amount: 120.0,
      amountWithTax: 132.0,
    },
    {
      status: "Completed",
      date: "2024-09-04",
      vendorName: "Furniture Depot",
      category: "Furniture",
      customerName: "Emily Davis",
      transactionType: "Purchase",
      amount: 180.0,
      amountWithTax: 198.0,
    },
    {
      status: "Pending",
      date: "2024-09-05",
      vendorName: "ElectroMart",
      category: "Electronics",
      customerName: "Chris Brown",
      transactionType: "Purchase",
      amount: 250.0,
      amountWithTax: 275.0,
    },
  ];


  const arAgingSum = [
    {
      customerName: "John Smith",
      totalFCY: 1000.0,
      current: 200.0,
      days1to15: 150.0,
      days16to30: 100.0,
      days31to45: 200.0,
      daysOver45: 350.0,
      total: 1000.0,
    },
    {
      customerName: "Jane Doe",
      totalFCY: 1500.0,
      current: 500.0,
      days1to15: 200.0,
      days16to30: 300.0,
      days31to45: 200.0,
      daysOver45: 300.0,
      total: 1500.0,
    },
    {
      customerName: "Michael Johnson",
      totalFCY: 2000.0,
      current: 600.0,
      days1to15: 300.0,
      days16to30: 400.0,
      days31to45: 300.0,
      daysOver45: 400.0,
      total: 2000.0,
    },
    {
      customerName: "Emily Davis",
      totalFCY: 1200.0,
      current: 400.0,
      days1to15: 150.0,
      days16to30: 200.0,
      days31to45: 200.0,
      daysOver45: 250.0,
      total: 1200.0,
    },
    {
      customerName: "Chris Brown",
      totalFCY: 1800.0,
      current: 700.0,
      days1to15: 250.0,
      days16to30: 300.0,
      days31to45: 200.0,
      daysOver45: 350.0,
      total: 1800.0,
    },
  ];


  const salesOrderDetails = [
    {
      status: "Completed",
      date: "2024-09-01",
      salesOrder: "SO-001",
      contactName: "John Smith",
      amount: 1200.0,
    },
    {
      status: "Pending",
      date: "2024-09-05",
      salesOrder: "SO-002",
      contactName: "Jane Doe",
      amount: 2500.0,
    },
    {
      status: "Shipped",
      date: "2024-08-20",
      salesOrder: "SO-003",
      contactName: "Michael Johnson",
      amount: 3200.0,
    },
    {
      status: "Completed",
      date: "2024-09-10",
      salesOrder: "SO-004",
      contactName: "Emily Davis",
      amount: 1800.0,
    },
    {
      status: "Cancelled",
      date: "2024-09-12",
      salesOrder: "SO-005",
      contactName: "Chris Brown",
      amount: 2100.0,
    },
  ];

  const vendorCreditDetails = [
    {
      status: "Issued",
      vendorCreditDate: "2024-09-01",
      creditNoteNumber: "CN-001",
      vendorName: "Vendor A",
      amount: 500.0,
      balanceAmount: 200.0,
    },
    {
      status: "Applied",
      vendorCreditDate: "2024-09-05",
      creditNoteNumber: "CN-002",
      vendorName: "Vendor B",
      amount: 1000.0,
      balanceAmount: 500.0,
    },
    {
      status: "Pending",
      vendorCreditDate: "2024-08-20",
      creditNoteNumber: "CN-003",
      vendorName: "Vendor C",
      amount: 750.0,
      balanceAmount: 300.0,
    },
    {
      status: "Issued",
      vendorCreditDate: "2024-09-10",
      creditNoteNumber: "CN-004",
      vendorName: "Vendor D",
      amount: 1200.0,
      balanceAmount: 700.0,
    },
    {
      status: "Expired",
      vendorCreditDate: "2024-09-12",
      creditNoteNumber: "CN-005",
      vendorName: "Vendor E",
      amount: 600.0,
      balanceAmount: 150.0,
    },
  ];

  const billsDetails = [
    {
      status: "Paid",
      billDate: "2024-09-01",
      dueDate: "2024-09-30",
      billNumber: "BILL-001",
      vendorName: "Vendor A",
      billAmount: 1200.0,
      balanceAmount: 0.0,
    },
    {
      status: "Pending",
      billDate: "2024-09-05",
      dueDate: "2024-10-05",
      billNumber: "BILL-002",
      vendorName: "Vendor B",
      billAmount: 2500.0,
      balanceAmount: 500.0,
    },
    {
      status: "Overdue",
      billDate: "2024-08-20",
      dueDate: "2024-09-20",
      billNumber: "BILL-003",
      vendorName: "Vendor C",
      billAmount: 3200.0,
      balanceAmount: 1000.0,
    },
    {
      status: "Paid",
      billDate: "2024-09-10",
      dueDate: "2024-10-10",
      billNumber: "BILL-004",
      vendorName: "Vendor D",
      billAmount: 1800.0,
      balanceAmount: 0.0,
    },
    {
      status: "Pending",
      billDate: "2024-09-12",
      dueDate: "2024-10-12",
      billNumber: "BILL-005",
      vendorName: "Vendor E",
      billAmount: 2100.0,
      balanceAmount: 200.0,
    },
  ];

  
  const creditNoteDetails = [
    {
      status: "Issued",
      creditDate: "2024-09-01",
      creditNoteNumber: "CN-001",
      customerName: "John Smith",
      creditNoteAmount: 500.0,
      balanceAmount: 200.0,
    },
    {
      status: "Applied",
      creditDate: "2024-09-05",
      creditNoteNumber: "CN-002",
      customerName: "Jane Doe",
      creditNoteAmount: 1000.0,
      balanceAmount: 500.0,
    },
    {
      status: "Pending",
      creditDate: "2024-08-20",
      creditNoteNumber: "CN-003",
      customerName: "Michael Johnson",
      creditNoteAmount: 750.0,
      balanceAmount: 300.0,
    },
    {
      status: "Issued",
      creditDate: "2024-09-10",
      creditNoteNumber: "CN-004",
      customerName: "Emily Davis",
      creditNoteAmount: 1200.0,
      balanceAmount: 700.0,
    },
    {
      status: "Expired",
      creditDate: "2024-09-12",
      creditNoteNumber: "CN-005",
      customerName: "Chris Brown",
      creditNoteAmount: 600.0,
      balanceAmount: 150.0,
    },
  ];

  const purchaseOrderVendor = [
    { vendorName: "Vendor A", purchaseOrderCount: 5, amount: 12000.0 },
    { vendorName: "Vendor B", purchaseOrderCount: 3, amount: 7500.0 },
    { vendorName: "Vendor C", purchaseOrderCount: 4, amount: 10000.0 },
    { vendorName: "Vendor D", purchaseOrderCount: 2, amount: 5000.0 },
    { vendorName: "Vendor E", purchaseOrderCount: 6, amount: 18000.0 },
  ];

  const purchaseOrderDetail = [
    {
      status: "Shipped",
      date: "2024-09-01",
      deliveryDate: "2024-09-07",
      purchaseOrderNumber: "PO-001",
      vendorName: "Vendor A",
      amount: 1200.0,
    },
    {
      status: "Pending",
      date: "2024-09-05",
      deliveryDate: "2024-09-12",
      purchaseOrderNumber: "PO-002",
      vendorName: "Vendor B",
      amount: 2500.0,
    },
    {
      status: "Delivered",
      date: "2024-08-20",
      deliveryDate: "2024-08-25",
      purchaseOrderNumber: "PO-003",
      vendorName: "Vendor C",
      amount: 3200.0,
    },
    {
      status: "Shipped",
      date: "2024-09-10",
      deliveryDate: "2024-09-15",
      purchaseOrderNumber: "PO-004",
      vendorName: "Vendor D",
      amount: 1800.0,
    },
    {
      status: "Pending",
      date: "2024-09-12",
      deliveryDate: "2024-09-19",
      purchaseOrderNumber: "PO-005",
      vendorName: "Vendor E",
      amount: 2100.0,
    },
  ];

  const items = [
    { label: "Today", value: "Today" },
    { label: "This Month", value: "This Month" },
    { label: "Last 3 Month", value: "Last 3 Months" },
    { label: "Last 6 Month", value: "Last 6 Months" },
    { label: "Last 12 Month", value: "Last 12 Months" },
    { label: "This Year", value: "This Year" },
    { label: "Custom", value: "Custom" },
  ];

  const coaStatus = [
    { label: "All", value: "All", status: true },
    { label: "Today", value: "Today", status: true },
    { label: "This Month", value: "This Month", status: true },
    { label: "This Year", value: "This Year", status: false },
    { label: "Custom", value: "Custom", status: false },
  ];
  const [statusSelected, setStatusSelected] = useState(coaStatus[0].value);
  const [filterSelected, setFilterSelected] = useState(coaStatus[0].value);

  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleCategory = (categoryID) => {
    setExpandedCategories((prevState) => ({
      ...prevState,
      [categoryID]: !prevState[categoryID],
    }));
  };

  const showItems = {
    shouldShow: ["Sales by Customer", "Sales by Item"],
    shouldShow1: ["Purchases by Vendor", "Purchases by Item"],
    shouldShow2: ["Sales Tax Summary", "Purchase Tax Summary"],
    
  };

  
  const value = showBasedOnChild?.value;
  const shouldShow = showItems.shouldShow.includes(value);
  const shouldShow1 = showItems.shouldShow1.includes(value);
  const shouldShow2 = showItems.shouldShow2.includes(value);
  

  // const handleDateRange = (date, dateString) => {
  //   setPassDteRange([dateString]);
  // };

  const handleDateRange = (dates, dateString) => {
    if (dateString && dateString.length === 2) {
      const startDate = moment(dateString[0])
        .startOf("month")
        .format("YYYY-MM-DD");
      const endDate = moment(dateString[1]).endOf("month").format("YYYY-MM-DD");
      const dateRangeString = `${startDate} - ${endDate}`;
      setPassDteRange([dateRangeString]);
    }
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const runReport = async (showBasedOnChild, prd) => {
    setIsProcess(true);
    let fromDate, toDate;
  
    if (prd === "Custom") {
      const dateRange = passDteRange[0];
      const [startDate, endDate] = dateRange.split(" - ");
      fromDate = startDate;
      toDate = endDate;
    } else {
      const now = moment();
    
      switch (prd) {
        case "This Month":
          fromDate = now.clone().startOf("month").format("YYYY-MM-DD");
          toDate = now.clone().endOf("month").format("YYYY-MM-DD");
          break;
    
        case "Last 3 Months":
          fromDate = now.clone().subtract(2, "months").startOf("month").format("YYYY-MM-DD");
          toDate = now.clone().endOf("month").format("YYYY-MM-DD");
          break;
    
        case "Last 6 Months":
          fromDate = now.clone().subtract(5, "months").startOf("month").format("YYYY-MM-DD");
          toDate = now.clone().endOf("month").format("YYYY-MM-DD");
          break;
    
        case "Last 12 Months":
          fromDate = now.clone().subtract(11, "months").startOf("month").format("YYYY-MM-DD");
          toDate = now.clone().endOf("month").format("YYYY-MM-DD");
          break;
    
        case "This Year":
          fromDate = now.clone().startOf("year").format("YYYY-MM-DD");
          toDate = now.clone().endOf("year").format("YYYY-MM-DD");
          break;
    
        default:
          fromDate = now.clone().startOf("month").format("YYYY-MM-DD");
          toDate = now.clone().endOf("month").format("YYYY-MM-DD");
          break;
      }
    }
    
    setfromDates(fromDate);
    setToDates(toDate);
    
  
    // base payload
    const datas = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      Period: prd,
      FromDate: fromDate,
      ToDate: toDate,
    };
  
    // Add Input field for tax summaries
    if (showBasedOnChild?.value === "Sales Tax Summary") {
      datas.Type = "Invoice";
    } else if (showBasedOnChild?.value === "Purchase Tax Summary") {
      datas.Type = "Expense";
    }
  
    const actions = {
      "profitandloss": async () => {
        summaryReport(prd, fromDate, toDate);
        const tradingRes = await rs.GetTradingReport(datas);
        setProfitAndLossDatas1(tradingRes.data.data[1]);
        setProfitAndLossDatas2(tradingRes.data.data[0]);
        setExportDatas(tradingRes);
      },
      "Sales by Customer": async () => {
        salesSummaryReport(prd, fromDate, toDate);
        const res = await rs.GetSalesByCustomer(datas);
        setSaleByCust(res.data.data);
        setExportDatas(res.data.data);
      },
      "Sales by Item": async () => {
        salesSummaryReport(prd, fromDate, toDate);
        const res = await rs.GetSalesByItem(datas);
        setSaleByItem(res.data.data);
        setExportDatas(res.data.data);
      },
      "balancesheet": async () => {
        const res = await rs.GetBalanceSheet(datas);
        setBalanceSheetAssets(res.data.data[0]);
        setBalanceSheetLiability(res.data.data[1]);
      },
      "Purchases by Vendor": async () => {
        GetPurchaseReportSumnmary(prd, fromDate, toDate);
        const res = await rs.GetPurchaseByVendor(datas);
        setPurchasebyVendor(res.data.data);
        setExportDatas(res.data.data);
      },
      "Purchases by Item": async () => {
        GetPurchaseReportSumnmary(prd, fromDate, toDate);
        const res = await rs.GetPurchaseByItem(datas);
        setPurchasebyItem(res.data.data);
        setExportDatas(res.data.data);
      },
      "Customer Balances": async () => {
        const res = await rs.GetCustomerBalance(datas);
        setCustBalance(res.data.data);
        setExportDatas(res.data.data);
      },
      "Vendor Balances": async () => {
        const res = await rs.GetVendorBalance(datas);
        setVendorBalance(res.data.data);
        setExportDatas(res.data.data);
      },
      "Invoice Details": async () => {
        const res = await rs.GetInvoiceDetailsReport(datas);
        setInvoiceDetails(res.data.data);
        setExportDatas(res.data.data);
      },
      "Estimate Details": async () => {
        const res = await rs.GetEstimateDetailsReport(datas);
        setEstimateDetails(res.data.data);
        setExportDatas(res.data.data);
      },
      "Payments Received": async () => {
        const res = await rs.GetPaymentsReceived(datas);
        setPaymentReceved(res.data.data);
        setExportDatas(res.data.data);
      },
      "Time to Get Paid": async () => {
        const res = await rs.GetTimeToGetPaid(datas.TenantID);
        setToGetPaid(res.data.data);
        setExportDatas(res.data.data);
      },
      "Expense Summary by Category": async () => {
        const res = await rs.GetExpensesByCategory(datas);
        setExpenseSummaryByCat(res.data.data);
        setExportDatas(res.data.data);
      },
      "Tax Summary": async () => {
        const res = await rs.GetTaxSummary(datas);
        setTaxSummary(res.data.data);
        setExportDatas(res.data.data);
      },
      "Sales Tax Summary": async () => {
        const res = await rs.GetItemsTaxReport(datas);
        GetItemsTaxSummary(datas);
        setSpTaxSummary(res.data.data);
        setExportDatas(res.data.data);
      },
      "Purchase Tax Summary": async () => {
        const res = await rs.GetItemsTaxReport(datas);
        GetItemsTaxSummary(datas);
        setSpTaxSummary(res.data.data);
        setExportDatas(res.data.data);
      },
      "cashflowstatement": async () => {
        const res = await rs.GetCashFlowStatement(datas);
        setCashFlow(res.data.data);
        setExportDatas(res.data.data);
      },
      "Sales Return": async () => {
        const res = await rs.GetSalesCreditNoteReport(datas);
        setSalesReturn(res.data.data);
        setExportDatas(res.data.data);
      },
      "Purchase Return": async () => {
        const res = await rs.GetPurchaseDebitNoteReport(datas);
        setPurchaseReturn(res.data.data);
        setExportDatas(res.data.data);
      },
      default: async () => {
        if (isRowView) {
          const tradingRes = await rs.GetTradingReport(datas);
          setProfitAndLossDatas1(tradingRes.data.data[1]);
          setProfitAndLossDatas2(tradingRes.data.data[0]);
        }
      }
    };
  
    const action = actions[showBasedOnChild?.value] || actions.default;
  
    try {
      await action();
    } catch (err) {
    } finally {
      setIsProcess(false);
    }
  };
  
  
  const summaryReport = (period, fromdate, todate) => {
    setIsProcess(true);
    const datas = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      Period: period,
      FromDate: fromdate,
      ToDate: todate,
    };
    rs.GetProfitAndLossSummary(datas)
      .then((res) => {
        setIsProcess(false);
        setSummary(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const salesSummaryReport = (period, fromdate, todate) => {
    setIsProcess(true);
    const datas = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      Period: period,
      FromDate: fromdate,
      ToDate: todate,
    };
    rs.GetSalesReportSumnmary(datas)
      .then((res) => {
        setIsProcess(false);
        setSalesSummary(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const GetItemsTaxSummary = (taxdatas) => {
    setIsProcess(true);
    rs.GetItemsTaxSummary(taxdatas)
      .then((res) => {
        setIsProcess(false);
        setItemsTaxSummary(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const GetPurchaseReportSumnmary = (period, fromdate, todate) => {
    setIsProcess(true);
    const datas = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      Period: period,
      FromDate: fromdate,
      ToDate: todate,
    };
    rs.GetPurchaseReportSumnmary(datas)
      .then((res) => {
        setIsProcess(false);
        setPurchaseReportSummary(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const handleClick = (item) => {
    if (item.name === "all") {
      setShowAll(true);
      setSelectedItem(null);
    } else {
      setSelectedItem(item);
      setShowAll(false);
    }
  };

  const handleClickListItems = (parent, child) => {
    setShowBasedOnChild(child);
    runReport(child, "Last 3 Months");
    setIsAccDetails(true);
    const path = `${parent.label} > ${child.label}`;
    setSelectedItemDetails(path);
  };
  const handleClickListItems1 = ( child) => {
    setShowBasedOnChild(child);
    runReport(child, "Last 3 Months");
    setIsAccDetails(true);
    const path = `${child.parent} > ${child.label}`;
    setSelectedItemDetails(path);
  };

  const goback = () => {
    setIsAccDetails(false);
    setProfitAndLossDatas("");
    setPassDteRange("");
    setSummary("");
    setSelectPeriod("Last 3 Months");
    setShowBasedOnChild("");
    setExpandedRows(false);
    setIsRowView(true);
    setExportDatas("");
  };

  const exportToExcel = () => {
    if (!exportDatas || !exportDatas.length) return;
  
    // Check if the first invoiceNumber starts with "P"
    const isPurchaseCode = exportDatas[0].invoiceNumber?.toString().trim().toUpperCase().startsWith("P");
    const invoiceKey = isPurchaseCode ? "Purchase Code" : "Invoice Number";
  
    const dataToExport = exportDatas.map((item) => ({
      [invoiceKey]: item.invoiceNumber,
      "Company Name": item.companyName,
      "Item Name": item.itemName,
      "Item Type": item.itemType,
      Unit: item.unit,
      Quantity: item.quantity,
      Rate: `${currency} ${item.rate.toFixed(2)}`,
      "Total Tax": `${currency} ${(item.interTaxAmount + item.localTaxAmount + item.centralTaxAmount).toFixed(2)}`,
      "Total Amount": `${currency} ${item.totalAmount.toFixed(2)}`
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTaxSummary");
  
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "SalesTaxSummary.xlsx");
  };
  


  const rowExpansionTemplate = (data) => {
    return (
      <div className="">
        <DataTable
          stripedRows
          value={data.customerInvoiceList}
          className="expand-table "
        >
          <Column field="invoiceNumber" header="Invoice Number"></Column>
          <Column field="companyName" header="Company Name"></Column>
          <Column field="email" header="Email"></Column>
          <Column
            field="balancePayment"
            header=" Balance Amount"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.balancePayment.toFixed(2)}
          ></Column>
          <Column
            field="totalAmount"
            header=" Total Amount"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.totalAmount.toFixed(2)}
          ></Column>
          <Column
            field="renderStatusColumn"
            header="Status"
            body={(e) => statusBodyTemplate(e)}
          ></Column>
        </DataTable>
      </div>
    );
  };

  const rowExpansionTemplateSalesReturn = (data) => {
    return (
      <div className="">
        <DataTable
          stripedRows
          value={data.salesReturnItems}
          className="expand-table "
        >
          <Column field="itemName" header="Item Name"></Column>
          <Column field="itemType" header=" Item Type"></Column>
          <Column field="returnQuantity" header=" Return Quantity "></Column>
          <Column
            field="rate"
            header=" Rate"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.rate.toFixed(2)}
          ></Column>
          <Column 
  field="reason" 
  header="Return Reason" 
  body={(rowData) => rowData.reason ? rowData.reason : "-"} 
/>

          <Column
            field="totalAmount"
            header=" Total Amount"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.totalAmount.toFixed(2)}
          ></Column>
          <Column
            field="renderStatusColumn"
            header="Status"
            body={(e) => statusBodyTemplate(e)}
          ></Column>
        </DataTable>
      </div>
    );
  };
  const rowExpansionTemplatePurchaseReturn = (data) => {
    return (
      <div className="">
        <DataTable
          stripedRows
          value={data.purchaseReturnItemList}
          className="expand-table "
        >
          <Column field="itemName" header="Item Name"></Column>
          <Column field="itemType" header=" Item Type"></Column>
          <Column field="returnQuantity" header=" Return Quantity"></Column>
          <Column field="reason" header="Return Reason" body={(rowData) => rowData.reason ? rowData.reason : "-"} />
          <Column
            field="rate"
            header=" Rate"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.rate.toFixed(2)}
          ></Column>
          <Column
            field="totalAmount"
            header=" Total Amount"
            className="text-end amount-align"
            body={(a) => currency + " " + a?.totalAmount.toFixed(2)}
          ></Column>
          <Column
            field="renderStatusColumn"
            header="Status"
            body={(e) => statusBodyTemplate(e)}
          ></Column>
        </DataTable>
      </div>
    );
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "OPEN":
        return "orange";
      case "PARTIALLY PAID":
        return "processing";
      case "PAID":
        return "green";
      case "DRAFT":
        return "purple";
      case "OVERDUE":
        return "error";
      default:
        return "cyan";
    }
  };
  
  const renderStatusTag = (status) => {
    const statusClass = getStatusClass(status);
    return (
      <Tag bordered={false} color={statusClass}>
        {status}
      </Tag>
    );
  };
  
  const statusBodyTemplate = (rowData) => {
    const status = rowData.status.toUpperCase();
    return renderStatusTag(status);
  };
  
  const statusBodyTemplatePurchaseVendor = (rowData) => {
    const status = rowData.purchaseStatus.toUpperCase();
    return renderStatusTag(status);
  };

  const statusBodyTemplateExpenseCat = (rowData) => {
    const status = rowData.purchaseStatus.toUpperCase();
    return renderStatusTag(status);
  };
  


  // const statusBodyTemplate = (rowData) => {
  //   let status = rowData.status.toUpperCase();
  //   let statusClass;

  //   switch (status) {
  //     case "OPEN":
  //       statusClass = "orange";
  //       break;
  //     case "PARTIALLY PAID":
  //       statusClass = "processing";
  //       break;
  //     case "PAID":
  //       statusClass = "green";
  //       break;
  //     case "DRAFT":
  //       statusClass = "purple";
  //       break;
  //     case "OVERDUE":
  //       statusClass = "error";
  //       break;
  //     default:
  //       statusClass = "cyan";
  //   }

  //   return (
  //     <>
  //       {" "}
  //       <Tag bordered={false} color={statusClass}>
  //         {status}
  //       </Tag>
  //     </>
  //   );
  // };

  // const statusBodyTemplatePurchaseVendor = (rowData) => {
  //   let status = rowData.purchaseStatus.toUpperCase();
  //   let statusClass;

  //   switch (status) {
  //     case "OPEN":
  //       statusClass = "orange";
  //       break;
  //     case "PARTIALLY PAID":
  //       statusClass = "processing";
  //       break;
  //     case "PAID":
  //       statusClass = "green";
  //       break;
  //     case "DRAFT":
  //       statusClass = "purple";
  //       break;
  //     case "OVERDUE":
  //       statusClass = "error";
  //       break;
  //     default:
  //       statusClass = "cyan";
  //   }

  //   return (
  //     <>
  //       {" "}
  //       <Tag bordered={false} color={statusClass}>
  //         {status}
  //       </Tag>
  //     </>
  //   );
  // };

  const allowExpansion = (rowData) => {
    return rowData.customerInvoiceList.length;
  };
  const allowExpansionSalesReturn = (rowData) => {
    return rowData.salesReturnItems.length;
  };
  const allowExpansionPurchaseReturn = (rowData) => {
    return rowData.purchaseReturnItemList.length;
  };

  const allowExpansionPurchaseVendor = (rowData) => {
    return rowData.purchaseExpensesList.length;
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < 10; i++) {
      const startYear = currentYear - i - 1;
      const endYear = startYear + 1;
      years.push({
        label: `Apr ${startYear}- Mar ${endYear.toString()}`,
        value: `${startYear}-${endYear}`,
      });
    }

    setAcademicYears(years);
  }, []);

  return (
    <>
      <BlockUI blocked={isProcess}>
        {isAccDetails ? (
          <div>
            {showBasedOnChild?.value !== "Banking Summary" && <div className="row mx-auto">
              <div className="card card-borderless cc-greyCard-custm mb-3">
                <div className="ms-2 my-2 me-2">
                  <div className="d-flex justify-content-between flex-wrap align-items-center my-1">
                    <h5 className="m-0">{selectedItemDetails}</h5>
                    <div className="d-flex justify-content-between kk-table-header kk-header-sec cc-font-size-14">
                      <div className="col">
                        {selectPeriod === "Custom" && (
                          <Space
                            direction="vertical"
                            className="col-auto me-3"
                            size={12}
                          >
                            <RangePicker
                              onChange={handleDateRange}
                              picker="month"
                              className="p-2"
                            />
                          </Space>
                        )}
                     {shouldShow2 &&   <Button
            label="Export"
            icon="pi pi-upload"
            className="py-1 mx-2 kk-btnThin my-auto p-button-help"
            style={{
              backgroundColor: "#dddddd",
              border: "none",
              color: "black",
            }}
            onClick={exportToExcel}
          />}
                        {showBasedOnChild?.value !== "Time to Get Paid" &&
                         <Primedropdown
                          value={selectPeriod}
                          onChange={(e) => {
                            setSelectPeriod(e.value);
                            if(e.value !== 'Custom') runReport(showBasedOnChild, e.value);
                          }}
                          options={items}
                          optionLabel="label"
                          placeholder="Select status to filter"
                          className="col-auto text-start me-3 my-auto"
                        />}
                        
                      </div>
                    {selectPeriod === 'Custom' && <button
                      className="btn btn-primary me-2"
                      disabled={!selectPeriod}
                      onClick={() => runReport(showBasedOnChild, "Custom")}
                    >
                      Run Report
                    </button>}

                      {showBasedOnChild?.value === "profitandloss" && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={handleToggle}
                        >
                          {isRowView ? (
                            <Tooltip title="Change Vertical View">
                              <InsertRowRightOutlined />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Change Horizontal View">
                              <InsertRowBelowOutlined />
                            </Tooltip>
                          )}
                        </button>
                      )}
                      <button className="btn btn-danger" onClick={goback}>
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
            {showBasedOnChild?.value === "profitandloss" &&
              summary.length !== 0 && (
                <div className="cc-greyCard-custm card-borderless mb-3 p-2">
                  <div className="row">
                    {summary.map((x, i) => (
                      <div key={i} className="col-md-3 p-2">
                        <div className="d-flex ps-2">
                          <p className="ms-3 mb-0">
                            {x.title}
                            <br />
                            <b>{currency + " " + x?.amount.toFixed(2)}</b>
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            {showBasedOnChild?.value === "profitandloss" && (
              <ProfitandLoss isRowView={isRowView} profitAndLossDatas={profitAndLossDatas}
              expandedCategories={expandedCategories} profitAndLossDatas1={profitAndLossDatas1} profitAndLossDatas2={profitAndLossDatas2}
              toggleCategory={toggleCategory}
              />
            )}
          </div>
        ) : (
          <div>
            <div className="row mx-auto">
              <div className="card card-borderless cc-greyCard-custm mb-3">
                <div className="ms-2 my-2 me-2">
                  <div className="d-flex justify-content-between flex-wrap align-items-center mb-2">
                    <h4 className="m-0">Reports Center</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-2">
                <div
                  className="card card-borderless cc-greyCard-custm p-3"
                  style={{ height: "80vh", overflow: "auto" }}
                >
                  <h5>Report Category</h5>
                  <Divider className="mb-2" style={{ width: "94%" }} />
                  {menuList.map((item) => (
                    <div className="p-0" key={item.id}>
                      <p
                        className={`menu-item ${
                          showAll && item.name === "all" ? "highlight-pl" : ""
                        } ${
                          selectedItem?.id === item.id ? "highlight-pl" : ""
                        }`}
                        onClick={() => handleClick(item)}
                      >
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col">
  {!showAll ? (
    <div
      className="card card-borderless cc-greyCard-custm p-5"
      style={{ height: "80vh", overflow: "auto" }}
    >
      {selectedItem && selectedItem.children && (
        <div>
          <h5>{selectedItem.label}</h5>
          <ul className="list-unstyled ps-2">
            {selectedItem.children.map((child) => (
              <li
                style={{
                  color: "#408DFB",
                  cursor: "pointer",
                  padding: "8px 0",
                }}
                className="menu-item"
                key={child.id}
                onClick={() => handleClickListItems(selectedItem, child)}
              >
                {child.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <div
  className="card card-borderless cc-greyCard-custm p-3"
  style={{ height: "80vh", overflow: "auto" }}
>
  <div className="row g-3 d-flex align-items-stretch">
    {menuList.map((names) => (
      <div className="col-md-4 d-flex" key={names.id}>
        <div
          className="card card-borderless cc-greyCard-custm flex-grow-1"
          style={{
            border: "none",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.02)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
        >
          <div className="card-body p-3">
            <h5
              className="card-title"
              style={{ color: "#3E9D88", marginBottom: "0.7rem" }}
            >
              {names.label}
            </h5>
            <ul className="list-unstyled ps-3">
              {names.children.map((child) => (
                <li
                  key={child.id}
                  style={{
                    color: "#6c757d",
                    padding: "8px 0",
                    cursor: child.name === "summary" ? "default" : "pointer",
                  }}
                  onClick={child.name !== "summary" ? () => handleClickListItems1(child) : undefined} 
                  onMouseEnter={(e) => (e.target.style.color = child.name !== "summary" ? "rgb(64, 141, 251)" : "rgb(108, 117, 125)")}
                  onMouseLeave={(e) => (e.target.style.color = "#6c757d")}
                >
                  {child.label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  )}
</div>


            </div>
          </div>
        )}

        {shouldShow && salesSummary.length !== 0 && (
          <div className="cc-greyCard-custm card-borderless mb-3 p-2">
            <div className="row">
              {salesSummary.map((x, i) => (
                <div key={i} className="col-md-3 p-2">
                  <div className="d-flex ps-2">
                    <p className="ms-3">
                      {x.title}
                      <br />
                      <b>{x?.amount}</b>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
{shouldShow2 && itemsTaxSummary?.rate !== undefined && (() => {
  const totalTax =
    (itemsTaxSummary.interTaxAmount || 0) +
    (itemsTaxSummary.localTaxAmount || 0) +
    (itemsTaxSummary.centralTaxAmount || 0);

  return (
    <div className="card card-borderless p-1 mb-2">
      <div className="d-flex mb-3 gap-3">
        <div className="col-4">
          <div className="card border-0 text-center shadow-2 pt-2">
            <h6>Total Quantity</h6>
            <p className="text-xl font-bold mb-0">{itemsTaxSummary.quantity}</p>
          </div>
        </div>
        {/* <div className="col-3">
          <div className="card border-0 text-center shadow-2 pt-2">
            <h6>Total Rate</h6>
            <p className="text-xl font-bold mb-0">
              {currency + " " + itemsTaxSummary.rate.toFixed(2)}
            </p>
          </div>
        </div> */}
        <div className="col-4">
          <div className="card border-0 text-center shadow-2 pt-2">
            <h6>Total Tax</h6>
            <p className="text-xl font-bold mb-0">
              {currency + " " + totalTax.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="col-4">
          <div className="card border-0 text-center shadow-2 pt-2">
            <h6>Total Amount</h6>
            <p className="text-xl font-bold mb-0">
              {currency + " " + itemsTaxSummary.totalAmount.toFixed(2)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
})()}



        {showBasedOnChild?.value === "cashflowstatement" && (
          <CashFlow cashFlow={cashFlow} currency={currency}/>
        )}
        {showBasedOnChild?.value === "balancesheet" && (
          <BalanceSheet
            fromDate={fromDates}
            toDate={toDates}
            selectPeriod={selectPeriod}
            balanceSheetAssets={balanceSheetAssets}
            balanceSheetLiability={balanceSheetLiability}
          />
        )}

        {showBasedOnChild?.value === "Sales by Customer" && (
         <SalesByCust saleByCust={saleByCust} expandedRows={expandedRows}
        setExpandedRows={setExpandedRows} rowExpansionTemplate={rowExpansionTemplate} 
        allowExpansion={allowExpansion} />
        )}
        {showBasedOnChild?.value === "Sales by Item" && (
          <SalesByItems saleByItem={saleByItem} />
        )}
        {showBasedOnChild?.value === "Sales Return" && (
          <SalesReturn salesReturn={salesReturn} expandedRows={expandedRows} 
          setExpandedRows={setExpandedRows} rowExpansionTemplateSalesReturn={rowExpansionTemplateSalesReturn}
          allowExpansionSalesReturn={allowExpansionSalesReturn}/>
        )}
        {shouldShow1 && purchaseReportSummary.length !== 0 && (
          <div className="cc-greyCard-custm card-borderless mb-3 p-2">
            <div className="row">
              {purchaseReportSummary.map((x, i) => (
                <div key={i} className="col-md-3 p-2">
                  <div className="d-flex ps-2">
                    <p className="ms-3">
                      {x.title}
                      <br />
                      {x?.amount}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* {shouldShow2 && itemsTaxSummary?.length !== 0 && (
          <div className="cc-greyCard-custm card-borderless mb-3 p-2">
            <div className="row">
              {itemsTaxSummary?.map((x, i) => (
                <div key={i} className="col-md-3 p-2">
                  <div className="d-flex ps-2">
                    <p className="ms-3">
                      {x.title}
                      <br />
                      {x?.amount}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )} */}
        {showBasedOnChild?.value === "Purchases by Vendor" && (
          <PurchasebyVendor headers={headers} purchasebyVendor={purchasebyVendor}
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows} statusBodyTemplatePurchaseVendor={statusBodyTemplatePurchaseVendor}
         currency={currency} 
         allowExpansionPurchaseVendor={allowExpansionPurchaseVendor} />
        )}

        {showBasedOnChild?.value === "Purchases by Item" && (
          <PurchasebyItem headers1={headers1} purchasebyItem={purchasebyItem} currency={currency}/>
        )}

        {showBasedOnChild?.value === "Expense Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Vendor Name</th>
                  <th>Customer Name</th>
                  <th>Date</th>
                  <th className="text-end">Amount</th>
                  <th className="text-end">Amount With Tax</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {expenseDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.vendorName}</td>
                    <td>{item.customerName}</td>
                    <td>{item.date}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.amountWithTax.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Expense Summary by Category" && (
         <ExpenseSummarybyCategory expenseSummaryByCat={expenseSummaryByCat}  currency={currency}/>
        )}
        {showBasedOnChild?.value === "Purchase Return" && (
          <PurchaseReturn purchaseReturn={purchaseReturn} expandedRows={expandedRows} 
          setExpandedRows={setExpandedRows} rowExpansionTemplatePurchaseReturn={rowExpansionTemplatePurchaseReturn}
          allowExpansionPurchaseReturn={allowExpansionPurchaseReturn} currency={currency}/>
        )}

        {showBasedOnChild?.value === "Expenses by Customer" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Customer Name</th>
                  <th>Expense Count</th>
                  <th className="text-end">Expense Amount</th>
                  <th className="text-end">Expense Amount With Tax</th>
                </tr>
              </thead>
              <tbody>
                {expenseByCust.map((item, index) => (
                  <tr key={index}>
                    <td>{item.customerName}</td>
                    <td>{item.expenseCount}</td>
                    <td className="text-end">
                      {currency + " " + item.expenseAmount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.expenseAmountWithTax.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Expenses by Employee" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Vendor Name</th>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Customer Name</th>
                  <th>Transaction Type</th>
                  <th className="text-end">Amount</th>
                  <th className="text-end">Amount With Tax</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {expenseByEmployee.map((item, index) => (
                  <tr key={index}>
                    <td>{item.vendorName}</td>
                    <td>{item.date}</td>
                    <td>{item.category}</td>
                    <td>{item.customerName}</td>
                    <td>{item.transactionType}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.amountWithTax.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Customer Balances" && (
          <CustomerBalance custBalance={custBalance} currency={currency}/>
        )}

        {showBasedOnChild?.value === "AR Aging Summary By Invoice Due Date" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Customer Name</th>
                  <th className="text-end">Total (FCY)</th>
                  <th className="text-end">Current</th>
                  <th className="text-end">1-15 days</th>
                  <th className="text-end">16-30 days</th>
                  <th className="text-end">31-45 days</th>
                  <th className="text-end">&gt;45 days</th>
                  <th className="text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                {arAgingSum.map((item, index) => (
                  <tr key={index}>
                    <td>{item.customerName}</td>
                    <td className="text-end">
                      {currency + " " + item.totalFCY.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.current.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.days1to15.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.days16to30.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.days31to45.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.daysOver45.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.total.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {showBasedOnChild?.value === "Invoice Details" && (
          <InvoiceDetails invoiceDetails={invoiceDetails} currency={currency}/>
        )}

        {showBasedOnChild?.value === "Banking Summary" && (
          <BankTransaction goback={goback}/>
        )}

        {showBasedOnChild?.value === "Sales Order Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Date</th>
                  <th>Sales Order</th>
                  <th>Contact Name</th>
                  <th className="text-end">Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {salesOrderDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>{item.salesOrder}</td>
                    <td>{item.contactName}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {showBasedOnChild?.value === "Estimate Details" && (
          <EstimateDetails estimateDetails={estimateDetails} currency={currency}/>
        )}
        {showBasedOnChild?.value === "Payments Received" && (
          <PaymentsReceived paymentReceved={paymentReceved} currency={currency}/>
        )}
        {showBasedOnChild?.value === "Time to Get Paid" && (
          <TimetoGetPaid toGetPaid={toGetPaid}/>
        )}

        {showBasedOnChild?.value === "Credit Note Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Credit Date</th>
                  <th>Credit Note Number</th>
                  <th>Customer Name</th>
                  <th className="text-end">Credit Note Amount</th>
                  <th className="text-end">Balance Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {creditNoteDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.creditDate}</td>
                    <td>{item.creditNoteNumber}</td>
                    <td>{item.customerName}</td>
                    <td className="text-end">
                      {currency + " " + item.creditNoteAmount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.balanceAmount.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Vendor Balances" && (
          <VendorBalance vendorBalance={vendorBalance} currency={currency} />
        )}

        {showBasedOnChild?.value === "Bills Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Bill Date</th>
                  <th>Due Date</th>
                  <th>Bill Number</th>
                  <th>Vendor Name</th>
                  <th className="text-end">Bill Amount</th>
                  <th className="text-end">Balance Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {billsDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.billDate}</td>
                    <td>{item.dueDate}</td>
                    <td>{item.billNumber}</td>
                    <td>{item.vendorName}</td>
                    <td className="text-end">
                      {currency + " " + item.billAmount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.balanceAmount.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Vendor Credits Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Vendor Credit Date</th>
                  <th>Credit Note Number</th>
                  <th>Vendor Name</th>
                  <th className="text-end">Amount</th>
                  <th className="text-end">Balance Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {vendorCreditDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.vendorCreditDate}</td>
                    <td>{item.creditNoteNumber}</td>
                    <td>{item.vendorName}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {currency + " " + item.balanceAmount.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Purchase Order Details" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Date</th>
                  <th>Delivery Date</th>
                  <th>Purchase Order Number</th>
                  <th>Vendor Name</th>
                  <th className="text-end">Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrderDetail.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>{item.deliveryDate}</td>
                    <td>{item.purchaseOrderNumber}</td>
                    <td>{item.vendorName}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showBasedOnChild?.value === "Purchase Orders by Vendor" && (
          <div className="card card-borderless p-1">
            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th>Vendor Name</th>
                  <th className="text-end">Purchase Order Count</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrderVendor.map((item, index) => (
                  <tr key={index}>
                    <td>{item.vendorName}</td>
                    <td className="text-end">{item.purchaseOrderCount}</td>
                    <td className="text-end">
                      {currency + " " + item.amount.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        
        {showBasedOnChild?.value === "Tax Summary" && (
          <TaxSummary taxSummary={taxSummary}/>
        )}
{(showBasedOnChild?.value === "Sales Tax Summary" || showBasedOnChild?.value === "Purchase Tax Summary") && (
  <SalesTaxSummary spTaxSummary={spTaxSummary} currency={currency} itemsTaxSummary={itemsTaxSummary}/>
)}


        {isProcess && (
          <ProgressSpinner
            style={{
              width: "50px",
              height: "50px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            strokeWidth="2"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          />
        )}
      </BlockUI>
    </>
  );
};

export default ReportsCenter;
